import { useGivenPoints, useNeedsPayPayConnectWithYahooId } from '../../store/payment'
import { useViewer } from '../../store/stateMachine/state'

export function useDisplayGivenPoints() {
  const givenPoints = useGivenPoints()
  const needsPayPayConnect = useNeedsPayPayConnectWithYahooId()
  const viewer = useViewer()
  return { givenPoints, needsPayPayConnect, viewer }
}
